import { render, staticRenderFns } from "./MyAccount.html?vue&type=template&id=2c2f4188&scoped=true&"
import script from "./MyAccount.js?vue&type=script&lang=js&"
export * from "./MyAccount.js?vue&type=script&lang=js&"
import style0 from "./MyAccount.scss?vue&type=style&index=0&id=2c2f4188&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2f4188",
  null
  
)

export default component.exports